import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInvalidateHomeState } from '../../home/hooks/use-home-state'
import { outreachApi, outreachStatusQueryKey } from '../api'

// Requesting disconnect flips the campaign to DISCONNECTING server-side, so we
// invalidate the status query to immediately re-render the route into the
// blocking view (the polling query would otherwise pick it up on its next tick).
export function useRequestDisconnectMutation(startupId: string) {
  const queryClient = useQueryClient()
  // Losing the sender changes what Home is about — the wizard drops back to
  // reconnecting, and the sidebar CTA follows it. Without this both keep
  // offering the old next step until a full page load.
  const invalidateHome = useInvalidateHomeState(startupId)
  return useMutation({
    mutationFn: () => outreachApi.requestDisconnect(startupId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachStatusQueryKey(startupId) })
      await invalidateHome()
    },
  })
}
